import { SIGN, lineCurrency, symbol } from "./multiEntry";

export default function EntryTotals({ lines, accounts, currency }) {
  const byCur = {};
  lines.forEach((l) => {
    const amt = Number(l.amount) || 0;
    if (!amt) return;
    const c = lineCurrency(l, accounts, currency);
    byCur[c] = byCur[c] || { in: 0, out: 0 };
    if (SIGN[l.type] > 0) byCur[c].in += amt; else byCur[c].out += amt;
  });
  const curs = Object.keys(byCur);
  if (!curs.length) {
    return <div data-testid="ml-totals" className="text-xs text-[var(--muted-text)]">Totals appear as you enter amounts</div>;
  }
  const fmt = (c, n) => `${symbol(c)}${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  return (
    <div data-testid="ml-totals" className="flex flex-wrap gap-4">
      {curs.map((c) => {
        const t = byCur[c];
        const net = t.in - t.out;
        return (
          <div key={c} data-testid={`ml-totals-${c}`} className="flex items-baseline gap-3 font-mono text-xs">
            <span className="text-[10px] tracking-[0.2em] uppercase text-[var(--muted-text)]">{c}</span>
            <span className="text-[#3A8760]">+{fmt(c, t.in)}</span>
            <span className="text-[#E63946]">−{fmt(c, t.out)}</span>
            <span className="font-semibold" data-testid={`ml-net-${c}`}>Net {net < 0 ? "−" : ""}{fmt(c, Math.abs(net))}</span>
          </div>
        );
      })}
    </div>
  );
}
